import {
  Button,
  Col,
  Form,
  Input,
  message,
  Row,
  Space,
  Table,
} from "antd";
import {
  useCreateOrUpdateUserMutation,
  useGetAllUserQuery,
} from "../../services/user";
import { User } from "../../types/user";
import { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import UserForm from "./forms/createUpdateUserForm";
import GenericDrawer from "../drawer";
import { showError } from "../../ultils/helpers";
import MonoCell from "../mono-cell";

const UserManagementContent = () => {
  const { data: users } = useGetAllUserQuery();
  const [createOrUpdateUser, { data: createOrUpdateUserData, error: createOrUpdateUserError }] =
    useCreateOrUpdateUserMutation();
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  const openDrawer = (record: any) => {
    setSelectedUser(
      record
        ? {
            _id: record._id,
            user_name: record.user_name,
            email: record.email,
            role: record.user_role,
          }
        : null
    );
    setIsDrawerVisible(true);
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
    form.resetFields();
  };

  const handleSubmit = async (values: User) => {
    values._id = selectedUser?._id!;
    await createOrUpdateUser(values);
    closeDrawer();
  };

  useEffect(() => {
    if (createOrUpdateUserData) {
      messageApi.success("Thêm người dùng thành công");
    }
  }, [createOrUpdateUserData, messageApi]);

  useEffect(() => {
    if (createOrUpdateUserError) {
      showError(createOrUpdateUserError, messageApi);
    }
  }, [createOrUpdateUserError, messageApi]);

  const columns = [
    {
      title: "User name",
      dataIndex: "user_name",
      key: "user_name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text: string) => <MonoCell>{text}</MonoCell>,
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "Địa chỉ",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text: string) => new Date(text).toLocaleString(),
    },
    {
      title: "Last Updated",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text: string) => new Date(text).toLocaleString(),
    },
    {
      title: "",
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          <Button onClick={() => openDrawer(record)}>Cập nhật</Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="container" style={{ padding: "0 16px" }}>
      {contextHolder}

      {/* Header + Button */}
      <div className="page-head">
        <h1>Quản lý người dùng</h1>
        <Button type="primary" onClick={() => openDrawer(null)}>
          Thêm người dùng
        </Button>
      </div>

      <GenericDrawer
        width={550}
        visible={isDrawerVisible}
        onClose={closeDrawer}
        title={selectedUser ? "Cập nhật người dùng" : "Thêm người dùng"}
        formComponent={UserForm}
        formProps={{
          initialValues: selectedUser,
          onSubmit: handleSubmit,
          form: form,
        }}
      />

      {/* Search form */}
      {/* <div className="search_nhan_vien" style={{ marginBottom: "24px" }}>
        <Form layout="vertical">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={6}>
              <Form.Item name="user_name">
                <Input placeholder="Tên người dùng" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item name="email">
                <Input placeholder="Email" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item>
                <Space wrap>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SearchOutlined />}
                  >
                    Tìm kiếm
                  </Button>
                  <Button
                    // onClick={handleClickResetFormSearch}
                  >
                    Làm mới
                  </Button>
                </Space>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div> */}

      {/* Table */}
      <div style={{ overflowX: "auto" }}>
        <Table
          columns={columns}
          dataSource={users}
          rowKey="_id"
          scroll={{ x: "max-content" }}
        />
      </div>
    </div>
  );
};

export default UserManagementContent;
